import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { RateDataImpl } from "../model/impl/RateDataImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class RateDataImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: RateDataImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.isMarketConvention != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        RateDataImplEncoder.fidTypeMap.get(1),
        false,
        encodable.isMarketConvention,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.book != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        RateDataImplEncoder.fidTypeMap.get(2),
        true,
        encodable.book,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.spotMarketRate != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        RateDataImplEncoder.fidTypeMap.get(3),
        false,
        encodable.spotMarketRate,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.forwardMarketPoints != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        RateDataImplEncoder.fidTypeMap.get(4),
        false,
        encodable.forwardMarketPoints,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.marketAllIn != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        RateDataImplEncoder.fidTypeMap.get(5),
        false,
        encodable.marketAllIn,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.spotClientRate != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        RateDataImplEncoder.fidTypeMap.get(6),
        false,
        encodable.spotClientRate,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.forwardClientPoints != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        RateDataImplEncoder.fidTypeMap.get(7),
        false,
        encodable.forwardClientPoints,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.clientAllIn != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        RateDataImplEncoder.fidTypeMap.get(8),
        false,
        encodable.clientAllIn,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.componentRateData != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        true,
        RateDataImplEncoder.fidTypeMap.get(9),
        false,
        encodable.componentRateData,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.baseCcyCd != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        RateDataImplEncoder.fidTypeMap.get(10),
        false,
        encodable.baseCcyCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.nonbaseCcyCd != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        false,
        RateDataImplEncoder.fidTypeMap.get(11),
        false,
        encodable.nonbaseCcyCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.localBook != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        RateDataImplEncoder.fidTypeMap.get(12),
        true,
        encodable.localBook,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        RateDataImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,RateDataImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.Boolean"],
    [2, "com.bcdfx.model.PositionBook"],
    [3, "java.math.BigDecimal"],
    [4, "java.math.BigDecimal"],
    [5, "java.math.BigDecimal"],
    [6, "java.math.BigDecimal"],
    [7, "java.math.BigDecimal"],
    [8, "java.math.BigDecimal"],
    [9, "com.bcdfx.model.RateData"],
    [10, "java.lang.String"],
    [11, "java.lang.String"],
    [12, "com.bcdfx.model.PositionBook"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: RateDataImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            RateDataImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.isMarketConvention = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: CubiqTS.PositionBook = this.baseEncoder.readObject(
            true,
            false,
            RateDataImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.book = <CubiqTS.PositionBook>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            RateDataImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.spotMarketRate = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            RateDataImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.forwardMarketPoints = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            RateDataImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.marketAllIn = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            RateDataImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.spotClientRate = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            RateDataImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.forwardClientPoints = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            RateDataImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.clientAllIn = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: Array<CubiqTS.RateData> = this.baseEncoder.readObject(
            false,
            true,
            RateDataImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.componentRateData = <Array<CubiqTS.RateData>>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            RateDataImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.baseCcyCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            RateDataImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.nonbaseCcyCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: CubiqTS.PositionBook = this.baseEncoder.readObject(
            true,
            false,
            RateDataImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.localBook = <CubiqTS.PositionBook>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            RateDataImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,RateDataImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return RateDataImplEncoder.fidTypeMap.has(fid);
  }
}
